const textToTranslate: Record<string, boolean> = {};
const showWarning = import.meta.client && import.meta.dev;

// mark text as needing translation
export function translateMe(text: string): string {
    if (showWarning && textToTranslate[text] === undefined) {
        console.warn(`translation needed: "${text.replace(/\n\s+/g, " ")}"`);
        textToTranslate[text] = true;
    }
    return text;
}
